export const LOCATOR_URL =
  'https://gisportal.horrycounty.org/server/rest/services/Locators/County_Locator/GeocodeServer'

export const PARCEL_SERVICE_URL = 'https://www.horrycounty.org/parcelapp/rest/services/HorryCountyGISApp/MapServer/24'